export const NAME = "uploadContentOrderToBox";
